module.exports = __webpack_public_path__ + "img/jigsaw-back-2.43034135.png";